var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ banner: true, filter: _vm.filter }},[_c('img',{style:(`width: 100%;object-fit: cover;`),attrs:{"src":_vm.img,"alt":""}}),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"cont-tit"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"cont-sub"},[_vm._v(_vm._s(_vm.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }